export default __webpack_public_path__ + "static/media/Card.6bbc52d3.mp3";